<script>
  // @ts-nocheck
  import { page } from '$app/stores';
  import { Bundle, Navigation } from '$lib/components';
  import { Routes } from '$lib/constants/routes.js';
  import { slugify } from '$lib/utils/common';

  export let data;
</script>

<slot />

<Navigation redirectTo={Routes.BUNDLES_LISTINGS} keyword isWithSearch={false} />

<div
  class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
  aria-hidden="true"
>
  <div
    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
    style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
  />
</div>

<main>
  <section>
    <div class="max-w-screen-xl px-4 py-0 sm:px-6 lg:px-8 mx-auto mt-16 pb-20">
      <div class="pt-8 sm:pt-6 lg:pt-8 mx-auto">
        <h1 class="font-extrabold tracking-tight text-slate-900 text-3xl mb-8 flex items-center">
          Bundles

          <svg
            class="ml-2 h-8 w-8 inline-block fill-indigo-600"
            viewBox="-4 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>crown</title>
            <path
              d="M12 10.938c-1.375 0-2.5-1.125-2.5-2.5 0-1.406 1.125-2.5 2.5-2.5s2.5 1.094 2.5 2.5c0 1.375-1.125 2.5-2.5 2.5zM2.031 9.906c1.094 0 1.969 0.906 1.969 2 0 1.125-0.875 2-1.969 2-1.125 0-2.031-0.875-2.031-2 0-1.094 0.906-2 2.031-2zM22.031 9.906c1.094 0 1.969 0.906 1.969 2 0 1.125-0.875 2-1.969 2-1.125 0-2.031-0.875-2.031-2 0-1.094 0.906-2 2.031-2zM4.219 23.719l-1.656-9.063c0.5-0.094 0.969-0.375 1.344-0.688 1.031 0.938 2.344 1.844 3.594 1.844 1.5 0 2.719-2.313 3.563-4.25 0.281 0.094 0.625 0.188 0.938 0.188s0.656-0.094 0.938-0.188c0.844 1.938 2.063 4.25 3.563 4.25 1.25 0 2.563-0.906 3.594-1.844 0.375 0.313 0.844 0.594 1.344 0.688l-1.656 9.063h-15.563zM3.875 24.5h16.25v1.531h-16.25v-1.531z"
            />
          </svg>
        </h1>
      </div>

      <h3 class="text-slate-900 text-xl tracking-tight font-bold mb-2">
        Accessible only to our Pro & Premium users
      </h3>
      <p class="mb-4 text-gray-600">
        Unlock exclusive access to advanced features and premium content, reserved only for our Pro
        & Premium users.
      </p>
      <div class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6 mb-10">
        {#each data.bundles as bundle (bundle.id)}
          <Bundle
            apps={bundle.apps}
            description={bundle.description}
            isOpen={$page.params.bundleSlug === slugify(bundle.name)}
            name={bundle.name}
          />
        {/each}
      </div>

      {#if data.paidBundles.length}
        <h3 class="text-slate-900 text-xl tracking-tight font-bold mb-2">
          Bundles created by users
        </h3>
        <p class="mb-4 text-gray-600">
          Discover user-created bundles designed to enhance your app experience. Pay once, enjoy
          forever!
        </p>
        <div class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
          {#each data.paidBundles as bundle (bundle.id)}
            <Bundle
              apps={bundle.apps}
              description={bundle.description}
              hasPaid={bundle.hasPaid}
              isOpen={$page.params.bundleSlug === slugify(bundle.name)}
              name={bundle.name}
              price={bundle.price}
            />
          {/each}
        </div>
      {/if}
    </div>
  </section>
</main>
